"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    width: "25",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M12.5,25C5.6,25,0,19.4,0,12.5S5.6,0,12.5,0S25,5.6,25,12.5S19.4,25,12.5,25z M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24 S24,18.8,24,12.5S18.8,1,12.5,1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M12.5,16.6c-0.1,0-0.2,0-0.3-0.1l-3-2C9.1,14.4,9,14.2,9,14.1v-3.2c0-0.2,0.1-0.3,0.2-0.4l3-2 c0.2-0.1,0.4-0.1,0.6,0l3,2c0.1,0.1,0.2,0.2,0.2,0.4v3.2c0,0.2-0.1,0.3-0.2,0.4l-3,2C12.7,16.5,12.6,16.6,12.5,16.6z M10,13.8 l2.5,1.6l2.5-1.6v-2.6l-2.5-1.6L10,11.2V13.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M12.5,6.5c-0.1,0-0.2,0-0.3-0.1l-1.6-1l0.5-0.9l1.4,0.8l1.4-0.8l0.5,0.9l-1.7,1 C12.7,6.5,12.6,6.5,12.5,6.5z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12",
    y: "4.4",
    fill: "#2C9FDA",
    width: "1",
    height: "4.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M12.5,8.5c-0.1,0-0.2,0-0.3-0.1l-1.6-1l0.5-0.9l1.4,0.8l1.4-0.8l0.5,0.9l-1.7,1 C12.7,8.5,12.6,8.5,12.5,8.5z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12",
    y: "16",
    fill: "#2C9FDA",
    width: "1",
    height: "4.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M13.9,20.4l-1.4-0.8l-1.4,0.8l-0.5-0.9l1.6-1c0.2-0.1,0.4-0.1,0.5,0l1.7,1L13.9,20.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M13.9,18.4l-1.4-0.8l-1.4,0.8l-0.5-0.9l1.6-1c0.2-0.1,0.4-0.1,0.5,0l1.7,1L13.9,18.4z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "5.2",
    y: "14.6",
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 -6.2413 5.3132)",
    fill: "#2C9FDA",
    width: "4.6",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M7.3,17.4l-1-0.1l0.1-1.6L5,14.9L5.5,14l1.7,1c0.2,0.1,0.3,0.3,0.2,0.5L7.3,17.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M9.1,16.5l-1-0.1l0.1-1.6L6.8,14l0.5-0.9l1.7,1c0.2,0.1,0.3,0.3,0.2,0.5L9.1,16.5z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7",
    y: "7.6",
    transform: "matrix(0.4703 -0.8825 0.8825 0.4703 -4.7309 11.8528)",
    fill: "#2C9FDA",
    width: "1",
    height: "4.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M5.5,11L5,10.1l1.4-0.8L6.3,7.7l1-0.1l0.1,1.9c0,0.2-0.1,0.4-0.2,0.5L5.5,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M7.3,11.9l-0.5-0.9l1.4-0.8L8.1,8.6l1-0.1l0.1,1.9c0,0.2-0.1,0.4-0.2,0.5L7.3,11.9z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "17",
    y: "12.8",
    transform: "matrix(0.4703 -0.8825 0.8825 0.4703 -4.0974 23.4581)",
    fill: "#2C9FDA",
    width: "1",
    height: "4.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M17.7,17.4l-0.1-1.9c0-0.2,0.1-0.4,0.2-0.5l1.7-1l0.5,0.9l-1.4,0.8l0.1,1.6L17.7,17.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M15.9,16.5l-0.1-1.9c0-0.2,0.1-0.4,0.2-0.5l1.7-1l0.5,0.9l-1.4,0.8l0.1,1.6L15.9,16.5z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "15.2",
    y: "9.4",
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 -2.5855 9.3904)",
    fill: "#2C9FDA",
    width: "4.6",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M19.5,11l-1.7-1c-0.2-0.1-0.3-0.3-0.2-0.5l0.1-1.9l1,0.1l-0.1,1.6l1.4,0.8L19.5,11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#2C9FDA",
    d: "M17.7,11.9l-1.7-1c-0.2-0.1-0.3-0.3-0.2-0.5l0.1-1.9l1,0.1l-0.1,1.6l1.4,0.8L17.7,11.9z"
  }));
};

exports["default"] = _default;